import React, { useState, useEffect } from "react";
import {
  AddIcon,
  TrashCanIcon,
  Button,
  Header,
  Input,
  Dropdown,
  TextArea,
  InfoIcon,
} from "@fluentui/react-northstar";

import { useIntl } from "react-intl";

const WorkflowComponent = (props) => {
  const inputItems = ["AGENT_CONNECTED", "CUSTOMER_ABANDONED", "CALL_CONNECTED", "CALL_ENDED", "AGENT_DECLINED"];
  const inputActions = ["POST", "GET", "PUT"];
  const intl = useIntl();
  const [mappingKV, setMappingKV] = useState({ key: "", value: "" });
  const [mappingForms, setMappingForms] = useState([]);
  const [bodyText, setBodyText] = useState("");
  const [jsonError, setJsonError] = useState(false);
  const [duplicateError, setDuplicateError] = useState(false);
  useEffect(() => {
    const wf = props.workflow?.[0];
    if (!wf) return;
    // ➤ Initialisation mapping
    if (wf.dataQuery?.mapping) {
      const mappings = Object.entries(wf.dataQuery.mapping);
      if (mappings.length > 0 && mappingForms.length === 0) {
        const [[firstKey, firstValue], ...rest] = mappings;
        setMappingKV((prev) => {
          if (prev.key || prev.value) return prev;
          return { key: firstKey, value: firstValue };
        });
        setMappingForms(rest.map(([key, value]) => ({ key, value })));
      }
    }
    // ➤ Initialisation body
    if (wf.webhook?.body && bodyText === "") {
      setBodyText(JSON.stringify(wf.webhook.body, null, 2)); // formaté
    }

  }, [props.workflow]);


  //sauvegarde mapping
  const saveMapping = (forms) => {
    const safeForms = Array.isArray(forms) ? forms : mappingForms;

    const mappings =
      mappingKV.key?.trim() && mappingKV.value?.trim()
        ? [mappingKV, ...safeForms]
        : [...safeForms];

    const filtered = mappings.filter((m) => m?.key?.trim() && m?.value?.trim());

    const mappingObj = filtered.reduce((acc, { key, value }) => {
      acc[key.trim()] = value.trim();
      return acc;
    }, {});

    //  Passer directement l'objet complet
    props.getData("dataQuery.mapping", mappingObj);
  };

  // ajouter un form

  const handleAddForm = (forms, setForms, saveFn) => {
    if (forms.length < 9) {
      const updated = [...forms, { key: "", value: "" }];
      setForms(updated);
      saveFn(updated);
    } else {
      alert(intl.formatMessage({ id: "MAX_FORMS_ERROR" }));
    }
  };
  const handleFormChange = (index, field, value, forms, setForms, saveFn) => {
    let newValue = value.trimStart();

    // Si c'est une clé, on la force en majuscules
    if (field === "key") {
      newValue = newValue.toUpperCase();

      // Vérifier l'unicité
      const isDuplicate =
        forms.some((f, i) => i !== index && f.key === newValue) ||
        mappingKV.key === newValue; // éviter doublon avec le premier KV

      if (isDuplicate) {
        alert(intl.formatMessage({ id: "DUPLICATE_KEY_EXIST" }));
        return;
      }
    }

    const updated = [...forms];
    updated[index][field] = newValue;
    setForms(updated);
    saveFn(updated);
  };

  const handleRemoveForm = (index, forms, setForms, saveFn) => {
    const updated = [...forms];
    updated.splice(index, 1);
    setForms(updated);

    // Appeler saveMapping avec le dernier état
    saveFn(updated);
  };

  // rendu form dynamique
  const renderForm = (form, index, forms, setForms, saveFn) => (
    <div key={index} className="div-form">
      <Input
        value={form.key}
        placeholder="Key"
        className="input-form"
        onChange={(e, { value }) =>
          handleFormChange(index, "key", value, forms, setForms, saveFn)
        }
      />
      <Input
        value={form.value}
        placeholder="Value"
        className="second-input-form"
        onChange={(e, { value }) =>
          handleFormChange(index, "value", value, forms, setForms, saveFn)
        }
      />
      <Button
        icon={<TrashCanIcon />}
        text
        onClick={() => handleRemoveForm(index, forms, setForms, saveFn)}
      />
    </div>
  );

  return (
    <div className="div-container">
      <div className="div-flex">
        <Header as="h4" content={intl.formatMessage({ id: "TRIGGER_EVENT" })} />
        <Button
          className="btn-info-text"
          icon={<InfoIcon />}
          iconOnly
          text
          title={intl.formatMessage({ id: "INFO_TRIGGER_EVENT" })}
        />
      </div>

      <Dropdown
        className="child-title-call-flow"
        items={inputItems}
        placeholder="Trigger event"
        checkable
        defaultValue={props.workflow?.[0]?.triggerEvent || ""}
        value={props.workflow?.[0]?.triggerEvent || ""}
        onChange={(e, { value }) =>
          props.getData("triggerEvent", { key: "triggerEvent", value })
        }
        getA11ySelectionMessage={{
          onAdd: (item) => `${item} has been selected.`,
        }}
      />

      {/* DATA QUERY */}
      <div className="div-flex">
        <Header as="h4" content={intl.formatMessage({ id: "DATA_QUERY" })} />
        <Button
          className="btn-info-text"
          icon={<InfoIcon />}
          iconOnly
          text
          title={intl.formatMessage({ id: "INFO_DATA_QUERY" })}
        />
      </div>

      <div className="div-flex" style={{ alignItems: "start" }}>
        <Dropdown
          className="child-title-call-flow"
          items={inputActions}
          placeholder="Method"
          checkable
          defaultValue={props.workflow?.[0]?.dataQuery?.method || ""}
          value={props.workflow?.[0]?.dataQuery?.method || ""}
          onChange={(e, { value }) => {
            props.getData("dataQuery.method", {
              key: "method",
              value,
            });
          }}
          getA11ySelectionMessage={{
            onAdd: (item) => `${item} has been selected.`,
          }}
        />
        <TextArea
          className="textarea-style"
          resize="both"
          placeholder="Value"
          value={props.workflow?.[0]?.dataQuery?.url || ""}
          onChange={(e, { value }) => {
            props.getData("dataQuery.url", {
              key: "url",
              value: value.trimStart(),
            });
          }}
        />
      </div>
      {/* MAPPING */}
      <div className="div-style">
        <Header as="h4" content={intl.formatMessage({ id: "MAPPING" })} />
        <Button
          className="btn-info-text"
          icon={<InfoIcon />}
          iconOnly
          text
          title={intl.formatMessage({ id: "INFO_MAPPING" })}
        />
      </div>
      <div className="div-mapping-wrapper">
        <Input
          placeholder="Key"
          value={mappingKV.key || ""}
          className="input-style"
          onChange={(e, { value }) => {
            const upperValue = value.trimStart().toUpperCase();

            // Vérifier unicité par rapport aux forms
            const isDuplicate = mappingForms.some((f) => f.key === upperValue);

            if (isDuplicate) {
              alert("Cette clé existe déjà dans les mappings.");
              return;
            }
            setMappingKV({ ...mappingKV, key: upperValue });
          }}
          onBlur={saveMapping}
        />
        <Input
          placeholder="Value"
          value={mappingKV.value || ""}
          className="input-style"
          onChange={(e, { value }) => {
            setMappingKV({ ...mappingKV, value: value.trimStart() });
          }}
          onBlur={saveMapping}
        />
      </div>

      {mappingForms.map((form, index) =>
        renderForm(form, index, mappingForms, setMappingForms, saveMapping)
      )}

      <Button
        primary
        icon={<AddIcon />}
        text
        content={intl.formatMessage({ id: "ADD_NEW_VARIABLES" })}
        className="btn-style"
        onClick={() =>
          handleAddForm(mappingForms, setMappingForms, saveMapping)
        }
      />
      {/* WEBHOOK */}
      <div className="div-flex">
        <Header as="h4" content={intl.formatMessage({ id: "WEBHOOK" })} />
        <Button
          className="btn-info-text"
          icon={<InfoIcon />}
          iconOnly
          text
          title={intl.formatMessage({ id: "INFO_WEBHOOK" })}
        />
      </div>

      <div className="div-flex" style={{ alignItems: "start" }}>
        <Dropdown
          className="child-title-call-flow"
          items={inputActions}
          placeholder="Method"
          checkable
          defaultValue={props.workflow?.[0]?.webhook?.method || ""}
          value={props.workflow?.[0]?.webhook?.method || ""}
          onChange={(e, { value }) => {
            props.getData("webhook.method", {
              key: "method",
              value,
            });
          }}
          getA11ySelectionMessage={{
            onAdd: (item) => `${item} has been selected.`,
          }}
        />

        <TextArea
          className="textarea-style"
          resize="both"
          placeholder="Value"
          value={props.workflow?.[0]?.webhook?.url || ""}
          onChange={(e, { value }) => {
            props.getData("webhook.url", {
              key: "url",
              value: value.trimStart(),
            });
          }}
        />
      </div>
      {/* BODY */}
      <div className="div-style">
        <Header as="h4" content={intl.formatMessage({ id: "BODY" })} />
        <Button
          className="btn-info-text"
          icon={<InfoIcon />}
          iconOnly
          text
          title={intl.formatMessage({ id: "INFO_BODY" })}
        />
      </div>
      {/*     <TextArea
        placeholder="{'key':'Value'}"
        className={`textarea-json ${
          jsonError
            ? "textarea-error"
            : duplicateError
            ? "textarea-duplicate"
            : ""
        }`}
        resize="both"
        style={{ minHeight: "40px" }}
        value={bodyText}
        onChange={(e, { value }) => {
          setBodyText(value);

          const cleanText = value.trim();
          if (!cleanText) {
            setDuplicateError(false);
            setJsonError(false);
            return;
          }

          try {
            // ✅ On essaie de parser le JSON
            const obj = JSON.parse(cleanText.replace(/'/g, '"'));

            // 🔹 Transformer les clés en majuscules
            const upperObj = {};
            const keysSet = new Set();
            let hasDuplicate = false;

            Object.entries(obj).forEach(([key, val]) => {
              const upperKey = key.toUpperCase();

              if (keysSet.has(upperKey)) {
                hasDuplicate = true;
              }
              keysSet.add(upperKey);
              upperObj[upperKey] = val;
            });

            // 🔹 Gestion des doublons
            if (hasDuplicate) {
              setDuplicateError(true);
              alert(intl.formatMessage({ id: "DUPLICATE_KEYS_EXIST" }));
            } else {
              setDuplicateError(false);
            }

            // ✅ Pas d’erreur de JSON
            setJsonError(false);
          } catch (err) {
            // ⚠️ Si le JSON est invalide, on empêche le crash
            console.warn("Invalid JSON format:", err);
            setJsonError(true);
            setDuplicateError(false);
          }
        }}
        onBlur={saveBody}
      />*/}

      <TextArea
        placeholder="{'key':'Value'}"
        className={`textarea-json ${jsonError
          ? "textarea-error"
          : duplicateError
            ? "textarea-duplicate"
            : ""
          }`}
        resize="both"
        style={{ minHeight: "40px" }}
        value={bodyText}
        onChange={(e, { value }) => {
          setBodyText(value);
          const cleanText = value.trim();
          if (!cleanText) {
            setDuplicateError(false);
            setJsonError(false);
            return;
          }

          // 🧩 Détection de doublon à la volée (quand on tape ":")
          const lastChar = value.slice(-1);
          if (lastChar === ":") {
            const match = value.match(/["']?([A-Za-z0-9_]+)["']?\s*:\s*$/);
            if (match) {
              const newKey = match[1].toUpperCase();

              // Récupère toutes les clés avant ce moment
              const allKeys = Array.from(
                value
                  .slice(0, -1)
                  .matchAll(/["']?([A-Za-z0-9_]+)["']?\s*:/g)
              ).map((m) => m[1].toUpperCase());

              const isDuplicate = allKeys.filter((k) => k === newKey).length > 0;

              if (isDuplicate) {
                alert(`⚠️ Cette clé existe déjà : ${newKey}`);
                setDuplicateError(true);
              } else {
                setDuplicateError(false);
              }
            }
          }

          // ✅ On essaie juste de parser silencieusement pour voir si structure correcte
          try {
            let normalized = cleanText
              .replace(/'/g, '"')
              .replace(/([{,]\s*)([A-Za-z0-9_]+)\s*:/g, '$1"$2":')
              .replace(/\s*:\s*/g, ":")
              .replace(/\s*,\s*/g, ",")
              .replace(/\s*{\s*/g, "{")
              .replace(/\s*}\s*/g, "}");

            JSON.parse(normalized); // pas d’alerte ici
            setJsonError(false);
          } catch {
            // juste marquer l’erreur visuellement, sans alerte
            setJsonError(true);
          }
        }}
        onBlur={() => {
          const cleanText = bodyText.trim();
          if (!cleanText) return;

          try {
            // 🔍 Extraire toutes les clés du texte JSON brut
            const keyMatches = Array.from(
              cleanText.matchAll(/["']?([A-Za-z0-9_]+)["']?\s*:/g)
            ).map((m) => m[1].toUpperCase());

            const duplicates = keyMatches.filter(
              (key, index) => keyMatches.indexOf(key) !== index
            );
            if (duplicates.length > 0) {
              alert(`⚠️ Clés dupliquées détectées : ${[...new Set(duplicates)].join(", ")}`);
              setDuplicateError(true);
              return; // ne sauvegarde pas
            } else {
              setDuplicateError(false);
            }

            // 🧹 Normalisation avant JSON.parse
            const normalized = cleanText
              .replace(/'/g, '"')
              .replace(/([{,]\s*)([A-Za-z0-9_]+)\s*:/g, '$1"$2":')
              .replace(/\s*:\s*/g, ":")
              .replace(/\s*,\s*/g, ",")
              .replace(/\s*{\s*/g, "{")
              .replace(/\s*}\s*/g, "}");

            const obj = JSON.parse(normalized);

            // 🔠 Majuscules et save
            const upperObj = {};
            Object.entries(obj).forEach(([key, val]) => {
              upperObj[key.toUpperCase()] = val;
            });
            props.getData("webhook.body", upperObj);
            setJsonError(false);
          } catch {
            alert(intl.formatMessage({ id: "INVALID_JSON" }));
            setJsonError(true);
          }
        }}


      />




    </div>
  );
};

export default WorkflowComponent;
